import React from "react";
import GroupHeadAllDealsModal from "../../dashboard-util/dashboard-grouphead/group-head-all-deals-modal"
import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import PropTypes from "prop-types";

const TechGroupHeadAllDealsModal = ({ show, onHide, item }) => {
    const tableHeaders = ["Project Name", "Team", "MD/D/VP"];

    const renderProjectRow = (project) => (
        <tr key={project.ProjectId} data-testid={`project-${project.ProjectId}`}>
            <td className="col-md-1 col-sm-1 mt-2"> {project.ProjectName} </td>
            <td className="col-md-1 col-sm-1 mt-2 techMemberColumn">
                <ViewMembersPanelNew
                    members={project?.Members || []}
                    projects={project}
                    isHidden={true}
                />
            </td>
            <td className="col-md-1 col-sm-1 mt-2 techMemberColumn">
                <ViewMembersPanelNew
                    members={project?.GroupHeads || []}
                    projects={project}
                    isHidden={true}
                />
            </td>
        </tr>
    );

    return (
        <GroupHeadAllDealsModal
            show={show}
            onHide={onHide}
            item={item}
            departmentTitle="GIB/Technology"
            tableHeaders={tableHeaders}
            renderProjectRow={renderProjectRow}
        />
    );
};

TechGroupHeadAllDealsModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    item: PropTypes.shape({
        GroupHeadName: PropTypes.string,
        Projects: PropTypes.arrayOf(PropTypes.shape({
            GroupHeads: PropTypes.arrayOf(PropTypes.shape({
                Name: PropTypes.string,
            })),
            Members: PropTypes.arrayOf(PropTypes.shape({
                Name: PropTypes.string,
                Email: PropTypes.string,
                UserName: PropTypes.string,
                Department: PropTypes.string,
            })),
            ProjectId: PropTypes.number,
            ProjectName: PropTypes.string
        }))
    }).isRequired,
};

export default React.memo(TechGroupHeadAllDealsModal);
